




import ISiteSupportedLanguageDto from "./SiteSupportedLanguageDto.if";
import mappings from "./SiteSupportedLanguageDto.map";
import ISiteDto from "./SiteDto.if";
import SiteDto from "./SiteDto";

import Transformers from './private/transformer';
import { IModelSource } from "./private/db.if";
import DBUtil from './private/db.util';

function _site(this: ISiteSupportedLanguageDto, db: IModelSource): Promise<ISiteDto> {
    return DBUtil.loadSiteId<ISiteDto>(db, this.siteId, SiteDto);
}

export default (data: object) => { 
    const obj = Transformers.create<ISiteSupportedLanguageDto>(mappings, data); 

    /* addLinkables */
    obj.site = _site;

    return obj;
}

